<div class="outer">
  <div class="inner">
    <div class="prod-left">
      <h3 class="prod-head"><span style="color: #0f457f">Yohesky</span> Pimentel!</h3>
      <h4 class="prod-head-sub">Frontend developer</h4>
    </div>
    <div class="prod-right">
      <img
        src="https://github.com/abhinanduN/codepen/blob/master/human-image.png?raw=true"
        class="prod-human-img"
        alt="prod"
      />
    </div>
  </div>
</div>
